export var SlidePanelDirection;
(function (SlidePanelDirection) {
    SlidePanelDirection["Left"] = "left";
    SlidePanelDirection["Right"] = "right";
})(SlidePanelDirection || (SlidePanelDirection = {}));
